module.exports = __webpack_public_path__ + "static/media/16.ab4c6799.svg";